<script>
  import {createEventDispatcher} from 'svelte';

  import {addMonths, format, subDays, setDate} from 'date-fns';
  import {es} from 'date-fns/locale';

  import store from '../../../Stores/Trabajadores/ver-trabajador-store';

  import Caja from "../../UI/Caja.svelte";
  import Loading from "../../UI/Loading.svelte";
  import Subtitulo from "../../UI/Subtitulo.svelte";
  import Navegacion from "../../UI/Navegacion.svelte";

  import Tabla from "./Marcajes/Tabla.svelte";
  import Resumen from "./Marcajes/Resumen.svelte";
  import Boton from "../../UI/Boton.svelte";
  import {descarga} from "../../../Api/marcajes";

  const dispatch = createEventDispatcher();

  let fecha;
  $: fecha = setDate($store.fecha, 1)
  $: trabajador = $store.trabajador.trabajador

  const descargar = () => descarga(fecha, subDays(addMonths(fecha, 1), 1), [trabajador])
      .then(x => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(x.data);
        a.download = 'marcajes.xlsx';
        document.body.append(a);
        a.click();
        a.remove();
      })
      .catch(e => alert(e));
</script>

<style>
    .horizontal {
        display: flex;
        align-items: center;
    }

    .descargar {
        margin-right: 1em;
    }
</style>

<div class="marcajes">
    <Caja>
        <div slot="titulo">
            <Subtitulo icono="check">Marcajes del trabajador</Subtitulo>
        </div>

        <div slot="botones" class="horizontal">
            <div class="descargar">
                <Boton tamano="pequeno" icono="cloud_download" on:click={descargar}>
                    Descargar
                </Boton>
            </div>

            <Navegacion etiqueta="izquierda" on:cambio>
                {format(fecha, 'LLLL yyyy', {locale: es})}
            </Navegacion>
        </div>

        {#if !$store.cargando}
            <Resumen/>
            <Tabla/>
        {:else}
            <Loading/>
        {/if}
    </Caja>
</div>